import {GwtConfig} from 'OK/GwtConfig';
import {DispatcherJs} from 'OK/DispatcherJs';

let instance: BanDataCfgJs;

export interface IBanDataCfgData {
    state: string;
    blocks: string;
    sitezone: string;
    gId: string;
    isAM: string;
    inv: boolean;
    slotInv: boolean;
    checkViewportThreshold: number;
}

let silent: boolean;
const MIN_WIDE_RIGHT_COLUMN_WIDTH = 1334;

export class BanDataCfgJs extends GwtConfig<IBanDataCfgData> {

    constructor() {
        silent = true;
        super('BanData');
        if (!this.data) {
            this.data = {} as IBanDataCfgData
        }
        silent = false;
    }

    setData(data: IBanDataCfgData) {
        super.setData(data);

        if (!silent) {
            // конфиги обновляются первыми на странице - надо подолжать деактивации хуков и пульнуть UpdateEvent
            Promise.resolve().then(() => {
                DispatcherJs.get().updateEvent.trigger();
            });
        }
    }

    get stateId(): string {
        return this.data.state;
    }

    get sitezone(): string {
        return this.data.sitezone;
    }

    get groupId(): string {
        return this.data.gId;
    }

    get isaMember(): string {
        return this.data.isAM;
    }

    get blocks(): string {
        return this.data.blocks;
    }

    get inv(): boolean {
        return this.data.inv && (document.documentElement.clientWidth >= MIN_WIDE_RIGHT_COLUMN_WIDTH);
    }

    get slotInv(): boolean {
        return this.data.slotInv;
    }

    get checkInViewportThreshold(): number {
        return this.data.checkViewportThreshold;
    }

    static getInstance(): BanDataCfgJs {
        if (!instance) {
            instance = new BanDataCfgJs();
        }
        return instance;
    }
}